 console.log("Precheckout...");

// ============================================================
// UTM TRACKING
// ============================================================
function captureUTMs() {
    console.log("utm")
    const params = new URLSearchParams(window.location.search);
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];
    const utms = {};

    utmKeys.forEach(key => {
        const value = params.get(key);
        if (value) utms[key] = value;
    });

    if (Object.keys(utms).length > 0) {
        sessionStorage.setItem('utm_params', JSON.stringify(utms));
    }
}

function getStoredUTMs() {
    try {
        return JSON.parse(sessionStorage.getItem('utm_params')) || {};
    } catch (e) {
        return {};
    }
}

// ============================================================
// PARÁMETROS DE CHECKOUT (UTMs) + cupón del carrito
// ============================================================
// El cupón NO se puede pasar de forma confiable por la URL del checkout
// (/cart/c/<token>): ese permalink deriva del carrito, así que el cupón debe vivir
// DENTRO del carrito. Por eso se aplica en el cartCreate (input.discountCodes) y en la
// URL solo anexamos UTMs. getAppliedDiscountCode() lee el cupón del carrito nativo
// (objeto de cart.js / cart/update.js) para pasarlo al cartCreate.
function getAppliedDiscountCode(cart) {
    if (!cart) return null;
    const apps = cart.cart_level_discount_applications || [];
    const byCode = apps.find(a => a && a.type === 'discount_code' && a.title);
    if (byCode) return byCode.title;
    if (Array.isArray(cart.discount_codes) && cart.discount_codes.length) {
        const applied = cart.discount_codes.find(d => d && d.applicable !== false) || cart.discount_codes[0];
        return applied ? applied.code : null;
    }
    return null;
}

// Anexa los UTMs a la URL del checkout. Usa el separador correcto (? o &) según si
// la URL ya trae parámetros. (El cupón va en el cartCreate, no en la URL.)
function appendCheckoutParams(url) {
    const utms = getStoredUTMs();
    const params = Object.keys(utms).map(key => `${key}=${encodeURIComponent(utms[key])}`);
    if (!params.length) return url;
    const sep = (url.includes("?") || url.includes("&")) ? "&" : "?";
    return url + sep + params.join("&");
}

// Capturar UTMs al cargar cualquier página
captureUTMs();

// ============================================================
// CONFIGURACIÓN (desde window.PRECHECKOUT_CONFIG — ver home.liquid)
// Este archivo se copia TAL CUAL entre clientes; lo específico vive en la config.
// ============================================================
const CFG = window.PRECHECKOUT_CONFIG || {};
const APP_PROXY = CFG.appProxy || "apps/apolo-ubigeo-calculation";
const CHECKOUT_BASE = (CFG.checkoutBase || "").replace(/\/+$/, "");
const COUNTRY = CFG.country || "PE";
const DOC_CFG = (CFG.documents && CFG.documents[COUNTRY]) || { person: [], company: null };

/* ============================================================
 * ESQUEMA ESTÁNDAR DE ATRIBUTOS (note_attributes del pedido)
 * Estas son las MISMAS claves en localStorage, en el carrito y las que
 * recibe el backend. Snake_case en inglés = una sola fuente de verdad.
 * ------------------------------------------------------------
 * Contacto:     first_name, last_name, email, phone
 * Documento:    document_type (dni|ce…), document_number
 * Comprobante:  receipt_type (boleta|factura), company_document (RUC/RUT), company_name
 * Despacho:     dispatch_mode (delivery|pickup), shipping_method (regular|express|programmed),
 *               pickup_store, delivery_date, delivery_time
 * Dirección:    country (PE|CL|EC), region, province, district, ubigeo, address, reference
 * Mapeo a Shopify GraphQL: region→province, province→city, address→address1,
 *               reference→address2, ubigeo→zip
 * ============================================================ */


/* -------------------------------------------------------------------------
 * 1. CONSTANTES Y ALMACENAMIENTO LOCAL
 * ------------------------------------------------------------------------- */
const CUSTOMER_KEY = "customerData";

function setCustomerData(field, value) {
    let data = JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
    data[field] = value;
    localStorage.setItem(CUSTOMER_KEY, JSON.stringify(data));
}

function getCustomerData(field) {
    let data = JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
    return data[field] || null;
}

function getAllCustomerData() {
    return JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
}

function clearCustomerData() {
    localStorage.removeItem(CUSTOMER_KEY);
}

function setLocalStorageCustomerData() {
    setCustomerData("first_name", $("#enova-billing-name").val());
    setCustomerData("last_name", $("#enova-billing-lastName").val());
    setCustomerData("email", $("#enova-billing-email").val());
    setCustomerData("phone", $("#enova-billing-telefono").val());
    setCustomerData("document_type", $("#enova-billing-documento-type").val());
    setCustomerData("document_number", $("#enova-billing-documento-number").val());

    setCustomerData("shipping_method", $('input[name="enova-despacho-tipo"]:checked').val());
    setCustomerData("dispatch_mode", $('input[name="enova-despacho"]:checked').val());
    setCustomerData("region", $("#enova-carrito-block-despacho-shipping__departamento").val());
    setCustomerData("province", $("#enova-carrito-block-despacho-shipping__provincia").val());
    setCustomerData("district", $("#enova-carrito-block-despacho-shipping__distrito").val());

    setCustomerData("address", $("#enova-despacho-direccion").val());
    setCustomerData("reference", $("#enova-despacho-referencia").val());

    setCustomerData("receipt_type", $('input[name="enova-billing-doc"]:checked').val());
    setCustomerData("company_document", $("#enova-billing-doc-ruc").val() || "");
    setCustomerData("company_name", $("#enova-billing-doc-razonsocial").val() || "");
    setCustomerData("loaded", false);
}

function setInitCustomerData() {
    const customerData = getAllCustomerData();
    if (Object.keys(customerData).length === 0) {
        if (window.ShopifyCustomer && window.ShopifyCustomer.logged_in) {
            $("#enova-billing-name").val(window.ShopifyCustomer.firstName);
            $("#enova-billing-lastName").val(window.ShopifyCustomer.lastName);
            $("#enova-billing-email").val(window.ShopifyCustomer.email);
        }
    } else {
        $("#enova-billing-name").val(getCustomerData("first_name"));
        $("#enova-billing-lastName").val(getCustomerData("last_name"));
        $("#enova-billing-email").val(getCustomerData("email"));
        $("#enova-billing-telefono").val(getCustomerData("phone"));
        $("#enova-billing-documento-type").val(getCustomerData("document_type"));
        $("#enova-billing-documento-number").val(getCustomerData("document_number"));

        let savedDispatchMode = getCustomerData("dispatch_mode");
        if (savedDispatchMode) {
            let $shippingRadio = $(`input[name="enova-despacho"][value="${savedDispatchMode}"]`);
            if ($shippingRadio.length) {
                $shippingRadio.prop('checked', true);
                $shippingRadio.closest('.enova-despacho-selector-item').click();
            }
        }

        if (savedDispatchMode == 'delivery') {
            $("#enova-despacho-shipping").css("display", "block");
            $("#enova-despacho-direccion").val(getCustomerData("address"));
            $("#enova-despacho-referencia").val(getCustomerData("reference"));
        } else {
            $("#enova-despacho-shipping").css("display", "none");
            $("#enova-despacho-recojo-tienda").css("display", "block");
        }

        let savedReceiptType = getCustomerData("receipt_type");
        if (savedReceiptType) {
            let $billingRadio = $(`input[name="enova-billing-doc"][value="${savedReceiptType}"]`);
            if ($billingRadio.length) {
                $billingRadio.prop('checked', true);
                $billingRadio.closest('.enova-billing-item').click();
            }
        }

        if (savedReceiptType == "factura") {
            $("#enova-billing-doc").css("display", "block");
            $("#enova-billing-doc-ruc").val(getCustomerData("company_document"));
            $("#enova-billing-doc-razonsocial").val(getCustomerData("company_name"));
        }
    }
}

/* -------------------------------------------------------------------------
 * 2. STOREFRONT API CLIENT & REDIRECCIÓN
 * ------------------------------------------------------------------------- */
// Inicialización del nuevo Storefront API Client Oficial de Shopify
const client = ShopifyStorefrontAPIClient.createStorefrontApiClient({
    storeDomain: CFG.storeDomain,
    apiVersion: CFG.apiVersion,
    publicAccessToken: CFG.storefrontToken,
    customFetchApi: window.fetch
});

async function populate(scope = "departaments", options) {
    try {
        let countrySelected = options.country;
        let departamentoSelected = options.departament;
        let provinceSelected = options.district;
        let urlBuilder = null;

        if(scope === "departaments") {
            urlBuilder = `?scope=departaments&country=${countrySelected}`;
        } else if (scope === "provinces") {
            urlBuilder = `?scope=provinces&country=${countrySelected}&departament=${departamentoSelected}`;
        } else if (scope === "distrits") {
            urlBuilder = `?scope=distrits&country=${countrySelected}&departament=${departamentoSelected}&province=${provinceSelected}`;
        }

        let departamentos = await fetch(`${window.Shopify.routes.root}${APP_PROXY}${ urlBuilder }`, {
            "method": "GET",
            "headers": { 'Content-Type': 'application/json' }
        })
        .then((res) => res.json())
        .then((response) => {
            let filteredResponse = response.filter((item) => {
                if("is_active" in item) {
                    return item.is_active;
                } else {
                    return item;
                }
            });
            return filteredResponse;
        })
        .then((response) => {
            console.log("response", response);
            return response;
        })
        .catch(error => console.error('Error:', error));

        console.log("UBIGEOS - ", scope, departamentos);
        return departamentos;

    } catch(err) {
         console.log("err", err);
         return err;
    }
}
 
async function getPickUpShopList(filter_zona = null) {
    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html("<p>Validando</p>");

    let shopsList = await fetch(`${window.Shopify.routes.root}${APP_PROXY}?scope=shop-addresses`, {
        "method": "GET",
        "headers": { 'Content-Type': 'application/json' }
    })
    .then((res) => res.json())
    .then((response) => response)
    .catch(error => console.error('Error:', error));

    console.log("lista de tiendas", shopsList);

    let list_stores_filtered = [];
    if(filter_zona) {
        list_stores_filtered = shopsList.filter((element) => {
            return element['department'] === filter_zona;
        });
        shopsList = list_stores_filtered;
    }

    let templateBlockStoreList = "";
    for(let store of shopsList) {
        let templateItemElement = `
            <label class="enova-carrito-block-despacho-recojo-tienda__list-tiendas--item" for="enova-despacho-recojo-tienda-item-${store.code}">
                <input type="radio" name="enova-despacho-recojo-tienda-item" id="enova-despacho-recojo-tienda-item-${store.code}" data-departamento="${store.department}" data-provincia="${store.province}" data-distrito="${store.distrit}" data-ubigeo="${store.ubigeo}" />
                <div class="enova-carrito-block-despacho-recojo-tienda__list-tiendas--item__text">
                    <h3 class="enova-tienda-titulo">${store.name}</h3>
                    <p class="enova-tienda-direccion">${store.address}</p>
                    <p class="enova-tienda-complement">${store.complement}</p>
                </div>
            </label>
        `;
        templateBlockStoreList += templateItemElement;
    }

    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html(templateBlockStoreList);

    setTimeout(() => {
        setStoresEventClick();
    }, 300);

    return shopsList;
}

async function getResponseCartItems(format = null) {
    let carritoItems = [];
    const responseCart = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' });
    const dataCart = await responseCart.json();

    const utf8_to_b64 = (str) => window.btoa(unescape(encodeURIComponent(str)));

    for (let item of dataCart.items) {
        let varianIdEncoded64 = `gid://shopify/ProductVariant/${item.variant_id}`;
        
        let getUbigeoSelected = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo");
        let getShippingMethod = jQuery("input[name=enova-despacho-tipo]:checked").val();
        let getDespacho = jQuery("input[name=enova-despacho]:checked").val();

        let existingAttributes = [];
        if (item.properties) {
            existingAttributes = Object.entries(item.properties).map(([key, value]) => ({
                key: key,
                value: String(value)
            }));
        }

        let newAttributes = [
            { key: "_tipo de despacho", value: String(getDespacho) },
            { key: "_shipping method", value: String(getShippingMethod) },
            { key: "_ubigeo", value: String(getUbigeoSelected) },
            { key: "_peso", value: String(item.grams) },
            { key: "_sku", value: String(item.sku) }
        ];

        let combinedAttributes = [...existingAttributes, ...newAttributes];

        let lineItemsToAdd = {
            variantId: utf8_to_b64(varianIdEncoded64),
            quantity: item.quantity,
            attributes: combinedAttributes
        };

        if (format) {
            lineItemsToAdd['requires_shipping'] = true; 
        }

        carritoItems.push(lineItemsToAdd);
    }
    // Adjuntamos el cupón del mismo cart.js (evita un segundo fetch). El array sigue
    // siendo iterable normal; solo lleva además .discountCodes para el cartCreate.
    const discountCode = getAppliedDiscountCode(dataCart);
    carritoItems.discountCodes = discountCode ? [discountCode] : [];
    return carritoItems;
}

async function serviceCart2CheckoutStoreFrontAPI(cartAttributes) {
    try {
        let carritoItemsList = await getResponseCartItems();
        
        // Mapeo estructurado para los atributos personalizados del carrito
        let cartAttributesList = [];
        for (let cartKey in cartAttributes.attributes) {
            cartAttributesList.push({
                key: cartKey,
                value: String(cartAttributes.attributes[cartKey])
            });
        }

        function getProvinceCorrelatives(province) {
            switch(province) {
                case "Lima":
                case "LIMA":
                    return "PE-LMA";
                default:
                    return province;
            }
        }

        // NUEVA MUTACIÓN: Usamos cartCreate (Válida en la API 2026)
        const cartCreateMutation = `
            mutation cartCreate($input: CartInput!) {
                cartCreate(input: $input) {
                    cart {
                        id
                        checkoutUrl
                    }
                    userErrors {
                        code
                        field
                        message
                    }
                }
            }
        `;

        // Cupón aplicado en el carrito nativo → se pasa al carrito de la Storefront API
        // (input.discountCodes). Es la forma confiable: viaja al checkout con el carrito,
        // no por la URL. Si el código es inválido, Shopify lo marca como no aplicable sin romper.
        // Ya viene resuelto desde getResponseCartItems (sin fetch extra).
        const discountCodes = carritoItemsList.discountCodes || [];

        const variables = {
            input: {
                attributes: cartAttributesList,
                ...(discountCodes.length ? { discountCodes } : {}),
                lines: carritoItemsList.map(item => ({
                    merchandiseId: item.variantId,
                    quantity: parseInt(item.quantity),
                    attributes: item.attributes
                })),
                buyerIdentity: {
                    email: cartAttributes.attributes.email,
                    phone: cartAttributes.attributes['phone'].startsWith("+") ? cartAttributes.attributes['phone'] : `+51${cartAttributes.attributes['phone']}`,
                    deliveryAddressPreferences: [
                        {
                            deliveryAddress: {
                                firstName: cartAttributes.attributes['first_name'],
                                lastName: cartAttributes.attributes['last_name'],
                                phone: cartAttributes.attributes['phone'].startsWith("+") ? cartAttributes.attributes['phone'] : `+51${cartAttributes.attributes['phone']}`,
                                country: "PE",
                                province: getProvinceCorrelatives(cartAttributes.attributes['region']),
                                city: String(cartAttributes.attributes['district']).trim(),
                                address1: String(cartAttributes.attributes['address']).trim(),
                                address2: String(cartAttributes.attributes['document_number']).trim(),
                                zip: String(cartAttributes.attributes['company_number'] ? cartAttributes.attributes['company_number'] : '')
                            }
                        }
                    ]
                }
            }
        };

        console.log("Ejecutando mutación cartCreate con variables:", variables);

        // Envío de la consulta mediante el nuevo SDK .request()
        const response = await client.request(cartCreateMutation, { variables });

        // Validación de errores adaptada al nuevo objeto Cart
        if (response.errors || response.graphQLErrors || (response.data && response.data.cartCreate.userErrors && response.data.cartCreate.userErrors.length > 0)) {
            let errorLog = response.graphQLErrors || response.errors || response.data?.cartCreate?.userErrors || [];
            console.error("--- DETALLE DE ERRORES DE SHOPIFY GRAPHQL ---");
            console.error(errorLog);
            console.error("---------------------------------------------");
            throw new Error(errorLog[0]?.message || "Error al procesar el Carrito en Shopify");
        }

        // Extraemos los datos del nuevo objeto de retorno
        const cartData = response.data.cartCreate.cart;
        console.log("Carrito creado satisfactoriamente en Shopify:", cartData);
        
        // Retornamos una simulación del objeto antiguo para no romper tu lógica de redirección del JS principal
        return { 
            checkout: { 
                id: cartData.id,
                webUrl: cartData.checkoutUrl // URL nativa de pasarela que incluye todos los datos pre-llenados
            } 
        };
        
    } catch(err) {
        console.log("Error crítico durante la creación del flujo de checkout:", err);
        checkoutButtonLoader(false);
        document.querySelector("#enova-message-carrito").textContent = "No se pudo iniciar el pago, por favor intente nuevamente en unos minutos.";
        document.querySelector("#enova-message-carrito").classList.add("active");
        return err;
    }
}

/* -------------------------------------------------------------------------
 * 3. LÓGICA Y REGLAS DE VALIDACIÓN
 * ------------------------------------------------------------------------- */
function validateDeliveryForm(objectForm) {
    let validated = true;
    for(let key in objectForm) {
        console.log("objectForm Value", objectForm[key]);
        if(!objectForm || objectForm[key] === '' || objectForm[key] === null) {
            validated = false;
        }
    }
    return validated;
}

function isCarritoProductTypeShipping(cartList) {
    let isCarritoReadyForShipping = false;
    
    for(let product of cartList) {
        let isShipping = product.requires_shipping;
        if(isShipping) {
            isCarritoReadyForShipping = true;
            break;
        }
    }

    if(cartList && cartList.length === 0) {
        isCarritoReadyForShipping = true;
    }

    return isCarritoReadyForShipping;
}

// MOCKUP temporal de fechas de entrega programada.
// Genera los próximos 7 días hábiles (salta domingos), empezando 1 día después de hoy.
// TODO: reemplazar por reglas reales (feriados/cortes) desde el backend cuando esté listo.
function setLogistictProgrammedDateRules() {
    const inputFecha = document.getElementById('enova-despacho-delivery-select-fecha');
    if (!inputFecha) return;

    const nombres = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const formatDDMMYYYY = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${d}-${m}-${y}`;
    };

    inputFecha.innerHTML = '';
    const temp = new Date();
    temp.setDate(temp.getDate() + 1);   // desde mañana

    let agregados = 0;
    while (agregados < 7) {
        if (temp.getDay() !== 0) {       // salta domingos
            const opt = document.createElement('option');
            opt.value = formatDDMMYYYY(temp);
            opt.textContent = `${nombres[temp.getDay()]}, ${formatDDMMYYYY(temp)}`;
            inputFecha.appendChild(opt);
            agregados++;
        }
        temp.setDate(temp.getDate() + 1);
    }
}

/* -------------------------------------------------------------------------
 * 4. UI / DOM UPDATES
 * ------------------------------------------------------------------------- */
function despachoMethodShippingLoading(status) {
    if (status === 'loading') {
        document.querySelector(".enova-despacho-shipping-loading").classList.add("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("disabled");
    } else {
        document.querySelector(".enova-despacho-shipping-loading").classList.remove("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("disabled");
    }
}

function checkoutButtonLoader(status) {
    if(status) {
        jQuery(".loader-button__text_container .loader-button__text").text("Cargando...");
        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "true");
        jQuery("#enova_cart-data-submit").css("pointer-events", 'none');
        jQuery("#enova_cart-data-submit").css("opacity", '.5');
    } else {
        jQuery(".loader-button__text_container .loader-button__text").text("Ir a Pagar");
        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "false");
        jQuery("#enova_cart-data-submit").css("pointer-events", 'initial');
        jQuery("#enova_cart-data-submit").css("opacity", '1');
    }
}

function setResetSelectorOptions(scope, addressBilling = null) {
    let templateList = `<option value="">Seleccione</option>`;
    if(scope === "departaments") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__departamento").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__departamento").html(templateList);
        }
    } else if(scope === "provinces") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__provincia").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__provincia").html(templateList);
        }
    } else if (scope === "distrits") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__distrito").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__distrito").html(templateList);
        }
    }
}

function setSelectorOptions(scope, optionList, addressBilling = null) {
    let templateList = '<option>Seleccione...</option>';
    for(let optionUbigeo of optionList) {
        let itemOptionTemplate = `
            <option value="${optionUbigeo.name}" data-ubigeo="${optionUbigeo.code}" data-code="${optionUbigeo.code}" data-id="${optionUbigeo.id}">${optionUbigeo.name}</option>
        `;
        templateList += itemOptionTemplate;
    }
    
    if(scope === "departaments") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__departamento").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__departamento").html(templateList);
        }
    } else if(scope === "provinces") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__provincia").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__provincia").html(templateList);
        }
    } else if (scope === "distrits") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__distrito").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__distrito").html(templateList);
        }
    }
}

function SetRenderShippingMethodsListOption(methodsList) {
    let templateList = '';
    let ubigeo = '';
    try {
        ubigeo = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo").toString();
    } catch (e) {}
    const horaActual = new Date().getHours();

    for (let method of methodsList) {
        let description = method.description || '';
        let methodName = method.name || '';

        if (method.display_rules && method.display_rules.rules && method.display_rules.rules.length > 0) {
            const matchedRule = method.display_rules.rules.find(rule => {
                if (rule.ubigeo_prefix === '*') return true;
                return ubigeo.startsWith(rule.ubigeo_prefix);
            });

            if (matchedRule) {
                if (matchedRule.cutoff_hour && matchedRule.before_cutoff && matchedRule.after_cutoff) {
                    description = horaActual < matchedRule.cutoff_hour
                        ? matchedRule.before_cutoff
                        : matchedRule.after_cutoff;
                } else {
                    description = matchedRule.default
                }

                if (matchedRule.override_name) {
                    methodName = matchedRule.override_name;
                }
            }
        }

        let templateItem = `
            <div class="enova-carrito-block-despacho-shipping-tipo__delivery--method">
                <input type="radio" name="enova-despacho-tipo" class="enova-delivery-method-1" id="enova-delivery-method-${method.code}" value="${method.code}">
                <label for="enova-delivery-method-${method.code}" class="enova-shipping-tipo__delivery-label enova-shipping-tipo__delivery--method1">
                    <div class="enova-shipping-method-tag-name-title">
                        <span class="enova-shipping-method-title">${methodName} </span>
                        <span class="enova-shipping-method-cost">
                            ${method.is_free_shipping ? 'Gratis' : `S/ ${method.price}`}
                        </span>
                    </div>
                    <div class="enova-shipping-method-tag-description">
                        <p>${description}</p>
                    </div>
                </label>
            </div>
        `;
        templateList += templateItem;
    }
    
    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").html(templateList);
    calculateShippingMethodToShowOption();
}

function setFakeButtonCart() {
    let templateButtonCart = `
        <div class="enova_terms_conditions_block">
            <label class="enova_terms_conditions_block_terms" for="terms_conditions" style="display: flex;flex-direction: row;align-content: inherit;align-items: baseline;">
                <input type="checkbox" id="terms_conditions"/>
                <p class="enova_terms_text" style="margin-left: 10px;">He leído y acepto los nuevos <a href="/policies/terms-of-service">Términos y Condiciones</a> de compra del sitio web.</p>
            </label>
        </div>
        <div id="enova_cart-data-submit" is="loader-button" class="cart__checkout-button checkout-button button button--primary button--full">
            <span class="loader-button__text_container">
            <span class="loader-button__text">
                        <span class="checkout-button__lock"><svg focusable="false" width="17" height="17" class="icon icon--lock   " viewBox="0 0 17 17">
                <path d="M2.5 7V15H14.5V7H2.5Z" stroke="currentColor" stroke-width="1.5" fill="none"></path>
                <path d="M5.5 4C5.5 2.34315 6.84315 1 8.5 1V1C10.1569 1 11.5 2.34315 11.5 4V7H5.5V4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"></path>
                <circle cx="8.5" cy="11" r="0.5" stroke="currentColor"></circle>
            </svg></span>Ir a pagar</span>
            <span class="loader-button__loader" hidden="">
                <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
                </div>
            </span>
            </span>
            <span class="loader-button__loader" hidden="">
                <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
                </div>
            </span>
        </div>
    `;

    if(document.querySelector(".cart__recap")) {
        document.querySelector(".cart__recap").innerHTML += templateButtonCart;
    } else {
        jQuery(".enova-carrito-block").after(templateButtonCart);
    }

    const submitBtn = document.querySelector("#enova_cart-data-submit");
    if(submitBtn) {
        submitBtn.addEventListener("click", handleCheckoutSubmit);
    }
}

/* -------------------------------------------------------------------------
 * 5. EVENTOS DE FORMULARIOS
 * ------------------------------------------------------------------------- */
function setFormDespacho() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-despacho-selector-item")) {
        buttonDespachoOption.addEventListener("click", (ev) => {
            for (let buttonDespachoOption of document.querySelectorAll(".enova-despacho-selector-item")) {
                buttonDespachoOption.classList.remove('active');
            }
          
            if(document.querySelector("input[name=enova-despacho]:checked")) {
                if( document.querySelector("input[name=enova-despacho]:checked").value === 'recojo-tienda' ) {
                    document.querySelector("#enova-despacho-recojo-tienda").classList.add("active");
                    document.querySelector("#enova-despacho-shipping").classList.remove("active");
    
                    document.querySelector("#enova-despacho-recojo-tienda").classList.remove("disabled");
                    document.querySelector("#enova-despacho-shipping").classList.add("disabled");
                    $("#enova-despacho-shipping").css("display", "none");
                    $("#enova-despacho-recojo-tienda").css("display", "block");

                    getPickUpShopList();

                    if( document.querySelector("#enova-despacho-delivery-select-fecha") ) {
                        document.querySelector("#enova-despacho-delivery-select-fecha").value = null;
                    }
                    if( document.querySelector("input[name=enova-despacho-tipo]:first-child") ) {
                        document.querySelector("input[name=enova-despacho-tipo]:first-child").checked = true;
                    }

                } else if ( document.querySelector("input[name=enova-despacho]:checked").value === 'delivery' ) {
                    document.querySelector("#enova-despacho-shipping").classList.add("active");
                    document.querySelector("#enova-despacho-recojo-tienda").classList.remove("active");
    
                    document.querySelector("#enova-despacho-shipping").classList.remove("disabled");
                    document.querySelector("#enova-despacho-recojo-tienda").classList.add("disabled");
                    $("#enova-despacho-shipping").css("display", "block");
                    $("#enova-despacho-recojo-tienda").css("display", "none");
                    
                    if( document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha") ) {
                        document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha").classList.remove("active");
                    }
                    if( document.querySelector("#enova-despacho-recojo-tienda-select-fecha") ) {
                        document.querySelector("#enova-despacho-recojo-tienda-select-fecha").value = null;
                    }
                }
                document.querySelector("input[name=enova-despacho]:checked").parentElement.classList.add('active');
            }
        });
    }
}

function setFormBillingDoc() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-billing-item")) {
        buttonDespachoOption.addEventListener("click", (ev) => {
            for (let buttonDespachoOption of document.querySelectorAll(".enova-billing-item")) {
                buttonDespachoOption.classList.remove('active');
            }
          
            if(document.querySelector("input[name=enova-billing-doc]:checked")) {
                if( document.querySelector("input[name=enova-billing-doc]:checked").value === 'factura' ) {
                    document.querySelector("#enova-billing-doc").classList.add("active");
                    document.querySelector("#enova-billing-doc").classList.remove("disabled");

                    if (document.querySelector("input[name=enova-despacho]:checked").value === 'recojo-tienda') {
                        jQuery("#formulario--billing-address_checkbox").prop("checked", false);
                        jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "block");
                        jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox").css("display", "none");
                    }
        
                } else if ( document.querySelector("input[name=enova-billing-doc]:checked").value === 'boleta' ) {
                    document.querySelector("#enova-billing-doc").classList.remove("active");
                    document.querySelector("#enova-billing-doc").classList.add("disabled");

                    jQuery("#formulario--billing-address_checkbox").prop("checked", true);
                    jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "none");
                    jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox").css("display", "block");
                }
                document.querySelector("input[name=enova-billing-doc]:checked").parentElement.classList.add('active');
            }
        });
    }
}

function setStoresEventClick() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item")) {
        buttonDespachoOption.addEventListener("click", (ev) => {
            for (let buttonDespachoOption of document.querySelectorAll(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item")) {
                buttonDespachoOption.classList.remove('active');
            }
          
            if(document.querySelector("input[name=enova-despacho-recojo-tienda-item]:checked")) {
                if(document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha")) {
                    document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha").classList.add("active");
                }
                if( document.querySelector("#enova-despacho-recojo-tienda-select-fecha") ) {
                    document.querySelector("#enova-despacho-recojo-tienda-select-fecha").value = null;
                }
                document.querySelector("input[name=enova-despacho-recojo-tienda-item]:checked").parentElement.classList.add('active');
            }
        });
    }
}

function setStoreListFilter() {
    jQuery("#enova-carrito-block-despacho-recojo__filtro").on("change", (ev) => {
        let filter_store_selected = ev.target.value;
        getPickUpShopList(filter_store_selected);
    });
}

function calculateShippingMethodByUbigeoSelected() {
    if( document.querySelector("#enova-carrito-block-despacho-shipping__distrito") ) {
        document.querySelector("#enova-carrito-block-despacho-shipping__distrito").addEventListener("change", () => {
             $(".enova-carrito-block-despacho-shipping__fecha").css("display", "none");
             despachoMethodShippingLoading('loading');

            if(
                document.querySelector("#enova-carrito-block-despacho-shipping__distrito") &&
                (
                    document.querySelector("#enova-carrito-block-despacho-shipping__distrito").value !== "0" &&
                    document.querySelector("#enova-carrito-block-despacho-shipping__distrito").value !== "Seleccione..."
                )
            ) {
                getResponseCartItems(true)
                    .then((carritoItemsListE) => {

                        {
                            despachoMethodShippingLoading('loading');
                            let SelectedDepartamentoUBIGEO = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo"); 
                            let totalWeight = 0

                            var carrito_productos = carritoItemsListE.map((el_producto) => {
                                // Las keys llevan prefijo "_" (privadas en Shopify, no se muestran en el template)
                                let selectedAttr_peso = el_producto.attributes.find((item_key) => item_key.key === "_peso");
                                let selectedAttr_sku = el_producto.attributes.find((item_key) => item_key.key === "_sku");
                                let pesoVal = selectedAttr_peso ? selectedAttr_peso.value : 0;
                                totalWeight = totalWeight + ( pesoVal ? parseFloat(pesoVal) : 0 )
                                return ({
                                    "sku": selectedAttr_sku ? selectedAttr_sku.value : "",
                                    "quantity": el_producto.quantity,
                                    "volumen_unit": null,
                                    "weight_unit": pesoVal ? parseFloat(pesoVal) : 0,
                                    "position": null
                                });
                            });
                            totalWeight = totalWeight / 1000
                            
                            let productCart = JSON.stringify(carrito_productos);
                            
                            let urlBuilder = `?scope=district-calc-rates&ubigeo=${SelectedDepartamentoUBIGEO}&products=${productCart}&weight=${totalWeight}`;

                            if(SelectedDepartamentoUBIGEO) {
                                fetch(`${window.Shopify.routes.root}${APP_PROXY}${ urlBuilder }`, {
                                    method: 'GET',
                                    headers:{ 'Content-Type': 'application/json' }
                                })
                                .then(res => res.json())
                                .then(response => {
                                    console.log('Success:', response);
                                    SetRenderShippingMethodsListOption(response);

                                    if (getCustomerData("shipping_method")) {
                                        let shippingMethodType = getCustomerData("shipping_method");
                                        $(`input[name="enova-despacho-tipo"][value="${shippingMethodType}"]`).prop('checked', true).trigger('change');
                                    }
                                    despachoMethodShippingLoading(null);
                                })
                                .catch(error => {
                                    console.error('Error:', error);
                                    despachoMethodShippingLoading(null);
                                });
                            } else {
                                alert("Debe seleccionar un Distrito Valido");
                            }
                        }
                    })
                    .catch((err) => {
                        console.log("err", err);
                        despachoMethodShippingLoading(null);
                    });
    
            } else {
                despachoMethodShippingLoading(null);
            }
        });
    }
}

function calculateShippingMethodToShowOption() {
    for(let methodOption of document.querySelectorAll("input[name=enova-despacho-tipo]")) {
        methodOption.addEventListener("change", (ev) => {
            if( document.querySelector("input[name=enova-despacho-tipo]:checked") ) {
                document.querySelector(".enova-carrito-block-despacho-shipping__fecha").classList.remove("active");
                $(".enova-carrito-block-despacho-shipping__fecha").css("display", "none");

                if( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "shipping-normal") {
                    // none
                } else if ( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "programmed" ) {
                    console.log("label programado");
                } else if ( document.querySelector("input[name=enova-despacho-tipo]:checked").value === "shipping-express" ) {
                    // none
                } else {
                    document.querySelector(".enova-carrito-block-despacho-shipping__fecha").classList.remove("active");
                }
            }
        });
    }
}

function setRenderCartFormKeypressValidation() {
    jQuery('.page-content form').on('keyup keypress', function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) { 
          e.preventDefault();
          return false;
        }
    });

    jQuery("#enova-billing-documento-type").on("change", (ev) => {
        jQuery("#enova-billing-documento-number").val("");
        $("p.text-has-error.text-typedoc").remove();
        document.querySelector("#enova-billing-documento-number").classList.remove("input-has-error");
    });

    jQuery("#enova-billing-documento-number").on("keypress", (ev) => {
        const selected = jQuery("#enova-billing-documento-type").val();
        const doc = (DOC_CFG.person || []).find(d => d.value === selected);
        if (!doc) return;
        const currentLength = ev.currentTarget.value.length;
        if (currentLength >= doc.maxLen) { ev.preventDefault(); return; }
        const regex = doc.numeric ? /^[0-9]$/ : /^[a-zA-Z0-9]$/;
        if (!regex.test(ev.key)) ev.preventDefault();
    });

    jQuery("#enova-billing-telefono").on("keypress", (ev) => {
        if (!/[0-9]/.test(ev.key)) ev.preventDefault();
    });

    // Documento de empresa (factura): numérico o alfanumérico según el país
    jQuery("#enova-billing-doc-ruc").on("keypress", (ev) => {
        const comp = DOC_CFG.company;
        const regex = (comp && comp.numeric === false) ? /^[a-zA-Z0-9]$/ : /^[0-9]$/;
        if (!regex.test(ev.key)) ev.preventDefault();
    });

    $("[for='enova-billing-telefono']").text("Celular");
}

function cartStep1() {
    let buttonCartCheckoutStep = document.querySelector(".enova_cart_button_step1");
    if (buttonCartCheckoutStep) {
        buttonCartCheckoutStep.addEventListener("click", (ev) => {
            let blockCartStep = document.querySelector(".enova-block-carrito-main");
            let blockCart = document.querySelector("#MinimogCart");
            document.querySelector("input[name=enova-despacho]:first-child").click();
        });
    }
}

function initSetFormDataUbigeosAvailable() {
    setResetSelectorOptions('departaments');
    setResetSelectorOptions('provinces');
    setResetSelectorOptions('distrits');
    setResetSelectorOptions('departaments', true);
    setResetSelectorOptions('provinces', true);
    setResetSelectorOptions('distrits', true);

    populate("departaments", { country: "1", departament: null, district: null })
    .then((result) => {
        let departmentsList = result ;
        setSelectorOptions("departaments", departmentsList);
        setSelectorOptions("departaments", departmentsList, true);
        
        let region = getCustomerData("region");
        if (region) {
            $("#enova-carrito-block-despacho-shipping__departamento").val(region).change();
        }
    })
    .catch((err) => console.log("err ubigeo selector departaments", err));

    jQuery("#enova-carrito-block-despacho-shipping__departamento").on("change", () => {
        setResetSelectorOptions('provinces');
        setResetSelectorOptions('distrits');

        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-shipping__departamento option:selected").data("id"); 

        populate("provinces", { country: "1", departament: SelectedDepartamentoID, district: null })
        .then((result) => {
            let provincesList = result ;
            setSelectorOptions("provinces", provincesList);

            let city = getCustomerData("province");
            if (city && $("#enova-carrito-block-despacho-shipping__departamento").val() == getCustomerData("region")) {
                $("#enova-carrito-block-despacho-shipping__provincia").val(city).change();
            }
        })
        .catch((err) => console.log("err ubigeo selector provinces", err));
    });

    jQuery("#enova-carrito-block-despacho-shipping__provincia").on("change", () => {
        setResetSelectorOptions('distrits');
        
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-shipping__departamento option:selected").data("id"); 
        let SelectedProvinciaID = jQuery("#enova-carrito-block-despacho-shipping__provincia option:selected").data("id"); 
        
        populate("distrits", { country: "1", departament: SelectedDepartamentoID, district: SelectedProvinciaID })
        .then((result) => {
            let districtList = result ;
            setSelectorOptions("distrits", districtList);

            let locality = getCustomerData("district");
            if (locality && $("#enova-carrito-block-despacho-shipping__provincia").val() == getCustomerData("province")) {
                $("#enova-carrito-block-despacho-shipping__distrito").val(locality);
                const distrito = document.querySelector("#enova-carrito-block-despacho-shipping__distrito");
                distrito.dispatchEvent(new Event("change", { bubbles: true }));
                $(`input[name="enova-despacho-tipo"][value="${getCustomerData("shipping_method")}"]`).prop('checked', true).trigger('change');
            }
        })
        .catch((err) => console.log("err ubigeo selector distrits", err));
    });

    jQuery("#enova-carrito-block-despacho-billing__departamento").on("change", () => {
        setResetSelectorOptions('provinces', true);
        setResetSelectorOptions('distrits', true);

        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-billing__departamento option:selected").data("id"); 

        populate("provinces", { country: "1", departament: SelectedDepartamentoID, district: null })
        .then((result) => setSelectorOptions("provinces", result, true))
        .catch((err) => console.log("err ubigeo selector provinces", err));
    });

    jQuery("#enova-carrito-block-despacho-billing__provincia").on("change", () => {
        setResetSelectorOptions('distrits', true);
        
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-billing__departamento option:selected").data("id"); 
        let SelectedProvinciaID = jQuery("#enova-carrito-block-despacho-billing__provincia option:selected").data("id"); 
        
        populate("distrits", { country: "1", departament: SelectedDepartamentoID, district: SelectedProvinciaID })
        .then((result) => setSelectorOptions("distrits", result, true))
        .catch((err) => console.log("err ubigeo selector distrits", err));
    });

    jQuery("#formulario--billing-address_checkbox").on("change", (ev) => {
        if(!jQuery("#formulario--billing-address_checkbox").prop("checked")) {
            jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "block");
        } else {
            jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "none");
        }
    });
}

/* -------------------------------------------------------------------------
 * 6. FLUJO DE CHECKOUT
 * ------------------------------------------------------------------------- */
function handleCheckoutSubmit(ev) {
    ev.preventDefault();

    if( !jQuery("#terms_conditions").prop("checked") ) {
        document.querySelector("#enova-message-carrito").textContent = "Debes aceptar los términos y condiciones";
        document.querySelector("#enova-message-carrito").classList.add("active");
        return false;
    }

    $("#enova-message-carrito").removeClass("active");
    document.querySelector("#enova-message-carrito").innerHTML = "";

    let type_document = document.querySelector("input[name=enova-billing-doc]:checked") ? document.querySelector("input[name=enova-billing-doc]:checked").value : '';

    function getShippingMatch() {
        let addressSelected = document.querySelector("#enova-despacho-direccion").value;
        let formateAddress = document.querySelector("#enova-despacho-direccion") ? addressSelected : "";
        return formateAddress;
    }

    var obj_params = {
        attributes: {
            'country': 'Peru',
            'dispatch_mode': document.querySelector("input[name=enova-despacho]:checked") ? (document.querySelector("input[name=enova-despacho]:checked").value === "recojo-tienda" ? "pickup" : document.querySelector("input[name=enova-despacho]:checked").value) : "",
            'region': document.querySelector("#enova-carrito-block-despacho-shipping__departamento  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__departamento  option:checked").textContent.trim() : "",
            'province': document.querySelector("#enova-carrito-block-despacho-shipping__provincia  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__provincia  option:checked").textContent.trim() : "",
            'district': document.querySelector("#enova-carrito-block-despacho-shipping__distrito  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__distrito  option:checked").textContent.trim() : "",
            'ubigeo': document.querySelector("#enova-carrito-block-despacho-shipping__distrito option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__distrito option:checked").dataset.code : "",
            'address': getShippingMatch(),
            'reference': document.querySelector("#enova-despacho-referencia") ? document.querySelector("#enova-despacho-referencia").value : '',
            'receipt_type': type_document,
            'email': document.querySelector("#enova-billing-email") ? document.querySelector("#enova-billing-email").value : "", 
            'first_name': document.querySelector("#enova-billing-name") ? document.querySelector("#enova-billing-name").value : "",
            'last_name': document.querySelector("#enova-billing-lastName") ? document.querySelector("#enova-billing-lastName").value : "", 
            'phone': document.querySelector("#enova-billing-telefono") ? document.querySelector("#enova-billing-telefono").value : "",
            'document_type': document.querySelector("#enova-billing-documento-type") ? document.querySelector("#enova-billing-documento-type").value : "",
            'document_number': document.querySelector("#enova-billing-documento-number") ? document.querySelector("#enova-billing-documento-number").value : ""
        }
    };

    if(document.querySelector("input[name=enova-despacho-tipo]:checked") && document.querySelector("input[name=enova-despacho-tipo]:checked").value === 'programmed') {
        obj_params['attributes']['delivery_date'] = document.querySelector("#enova-despacho-delivery-select-fecha").value;
        obj_params['attributes']['delivery_time'] = document.querySelector("#enova-despacho-delivery-select-horario").value;
    }

    if(document.querySelector("input[name=enova-billing-doc]:checked") && document.querySelector("input[name=enova-billing-doc]:checked").value === 'factura') {
        obj_params['attributes']['company_document'] = document.querySelector("#enova-billing-doc-ruc").value;
        obj_params['attributes']['company_name'] = document.querySelector("#enova-billing-doc-razonsocial").value;
    }

    if( document.querySelector("input[name=enova-despacho]:checked") && document.querySelector("input[name=enova-despacho]:checked").value === "delivery" ) {
        obj_params.attributes['shipping_method'] = document.querySelector("input[name=enova-despacho-tipo]:checked") ? document.querySelector("input[name=enova-despacho-tipo]:checked").value : '';
    }
    
    if( document.querySelector("input[name=enova-despacho]:checked") && document.querySelector("input[name=enova-despacho]:checked").value === "recojo-tienda" ) {
        obj_params.attributes['region'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.departamento : '';
        obj_params.attributes['province'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.provincia : '';
        obj_params.attributes['district'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.distrito : '';
        obj_params.attributes['ubigeo'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").dataset.ubigeo : '';
        obj_params.attributes['address'] = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? `Recojo Tienda: ${jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").parent().find(".enova-tienda-direccion").text()}` : "";
        obj_params.attributes['reference'] = '-';
        obj_params.attributes['pickup_store'] = jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked") ? jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked").parent().find(".enova-tienda-titulo").text() : '';

        if( obj_params && obj_params.attributes && obj_params.attributes['pickup_date'] && obj_params.attributes['delivery_time'] ) {
            obj_params.attributes['reference'] = `Fecha: ${obj_params.attributes['pickup_date']}, Horario: ${obj_params.attributes['delivery_time']}`;
        }
    }

    let formValid = true;
    const fieldsCommon = ['first_name', 'last_name', 'email', 'phone', 'document_type', 'document_number', 'country', 'dispatch_mode', 'receipt_type'];
    const fieldsDelivery = [...fieldsCommon, 'region', 'province', 'district', 'ubigeo', 'address', 'reference', 'shipping_method'];
    const fieldsPickup   = [...fieldsCommon];

    const dispatchMode = obj_params.attributes['dispatch_mode'] || 'delivery';
    const fieldsToValidate = (dispatchMode === 'pickup') ? fieldsPickup : fieldsDelivery;

    const $inputPhone     = $("#enova-billing-telefono");
    const $selectDocType  = $("#enova-billing-documento-type"); 
    const $inputDocNum    = $("#enova-billing-documento-number");
    const $msgContainer   = $("#enova-message-carrito");
    const $radioFactura   = $('input[name="enova-billing-doc"]:checked');
    const $inputRucFactura= $('#enova-billing-doc-ruc');

    $msgContainer.removeClass("active").text("");
    $inputDocNum.removeClass("input-has-error");
    $(".text-has-error.text-typedoc").remove();

    fieldsToValidate.forEach(key => {
        let value = obj_params.attributes[key];
        if (!value || value.trim() === '') {
            formValid = false;
        }
    });

    if ($inputPhone.val().length < 9) {
        formValid = false;
    }

    const docType = $selectDocType.val(); 
    const docNum  = $inputDocNum.val();
    const docLen  = docNum.length;
    let docMessage = "";
    let isDocValid = true;

    const personDoc = (DOC_CFG.person || []).find(d => d.value === docType);
    if (personDoc) {
        const okLen = docLen >= personDoc.minLen && docLen <= personDoc.maxLen;
        const okChars = personDoc.numeric ? /^[0-9]+$/.test(docNum) : /^[a-zA-Z0-9]+$/.test(docNum);
        if (!okLen || !okChars) {
            const lenTxt = personDoc.minLen === personDoc.maxLen
                ? `${personDoc.minLen}`
                : `entre ${personDoc.minLen} y ${personDoc.maxLen}`;
            docMessage = `El ${personDoc.label} debe tener ${lenTxt} caracteres${personDoc.numeric ? " numéricos" : " alfanuméricos"}.`;
            isDocValid = false;
        }
    }

    if (!isDocValid) {
        formValid = false;
        $msgContainer.text(docMessage).addClass("active");
        $inputDocNum.addClass("input-has-error");
        $inputDocNum.parent().append(`<p class='text-has-error text-typedoc'>${docMessage}</p>`);
    }

    if ($radioFactura.val() === "factura") {
        const comp = DOC_CFG.company;
        const rucVal = String($inputRucFactura.val() || "");
        let okComp;
        if (comp) {
            const okLen = rucVal.length >= comp.minLen && rucVal.length <= comp.maxLen;
            const okChars = comp.numeric ? /^[0-9]+$/.test(rucVal) : /^[a-zA-Z0-9]+$/.test(rucVal);
            okComp = okLen && okChars;
        } else {
            okComp = rucVal.trim().length > 0;
        }
        if (!okComp) {
            $inputRucFactura.addClass("input-has-error");
            formValid = false;
        }
    }

    if(formValid) {
        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "true");
        checkoutButtonLoader(true);

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },    
            body: JSON.stringify(obj_params)
        })
        .then(response => response.json())
        .then(response => {
            document.querySelector("#enova-message-carrito").classList.remove("active");

            serviceCart2CheckoutStoreFrontAPI(obj_params)
                .then((result) => {
                    if(result && result.message && result.name === "Error") {
                        checkoutButtonLoader(false);
                        throw result;
                    }
                    
                    // Manejo del WebUrl de redirección obtenido desde GraphQL
                    if(result && result.checkout && result.checkout.webUrl) {
                        checkoutButtonLoader(true);
                        setLocalStorageCustomerData();

                        let url_checkout_ = `${result.checkout.id}`;
                        // Construcción de la URL limpia basada en el ID del Checkout
                        url_checkout_ = `${CHECKOUT_BASE}/cart/c/${url_checkout_.split("gid://shopify/Cart/")[1] || url_checkout_.split("gid://shopify/Checkout/")[1]}&channel=buy_button&_fd=0`;

                        // UTMs → checkout (el cupón ya viaja dentro del carrito vía cartCreate)
                        url_checkout_ = appendCheckoutParams(url_checkout_);

                        window.location.href = url_checkout_;
                    } else {
                        throw result;
                    }
                })
                .catch((err) => {
                    console.log("Fallo el pre-checkout, aplicando fallback a checkout normal", err);
                    checkoutButtonLoader(false);

                    fetch(window.Shopify.routes.root + 'cart.js', {
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' }
                    })
                    .then(response => response.json())
                    .then(response => {
                        // Fallback: el token viene del carrito NATIVO, que ya trae el cupón aplicado
                        // por el cliente → viaja solo al checkout. Aquí solo anexamos UTMs.
                        let fallbackUrl = `${CHECKOUT_BASE}/checkouts/cn/${response.token}`;
                        fallbackUrl = appendCheckoutParams(fallbackUrl);
                        window.location.href = fallbackUrl;
                    })
                    .catch((err2) => {
                        document.querySelector("#enova-message-carrito").textContent = "No se pudo crear el pedido, algunos productos no están disponibles, por favor vuelve a intentar";
                        document.querySelector("#enova-message-carrito").classList.add("active");
                    });
                });
        })
        .catch((error) => {
            console.error('CART Error:', error);
        });

    } else {
        if (obj_params.attributes.email === "") document.querySelector("#enova-billing-email").classList.add("input-has-error");
        else document.querySelector("#enova-billing-email").classList.remove("input-has-error");
        
        if (obj_params.attributes.first_name === "") document.querySelector("#enova-billing-name").classList.add("input-has-error");
        else document.querySelector("#enova-billing-name").classList.remove("input-has-error");
        
        if (obj_params.attributes.last_name === "") document.querySelector("#enova-billing-lastName").classList.add("input-has-error");
        else document.querySelector("#enova-billing-lastName").classList.remove("input-has-error");
        
        if (obj_params.attributes.phone === "") {
          document.querySelector("#enova-billing-telefono").classList.add("input-has-error");
          if ( $(".text-has-error.text-phone").length == 0 ) $("#enova-billing-telefono").parent().append("<p class='text-has-error text-phone'>El celular debe tener 9 dígitos</p>");
        } else {
          if ( document.querySelector("#enova-billing-telefono").value.length < 9 ) {
            document.querySelector("#enova-billing-telefono").classList.add("input-has-error");
            if ( $(".text-has-error.text-phone").length == 0 ) $("#enova-billing-telefono").parent().append("<p class='text-has-error text-phone'>El celular debe tener 9 dígitos</p>");
          } else {
            document.querySelector("#enova-billing-telefono").classList.remove("input-has-error");
            $("p.text-has-error.text-phone").remove();
          }
        }
        
        if (obj_params.attributes["document_type"] === "") {
          document.querySelector("#enova-billing-documento-type").classList.add("input-has-error");
        } else {
          document.querySelector("#enova-billing-documento-type").classList.remove("input-has-error");
        }

        if (obj_params.attributes["document_number"] === "") {
          document.querySelector("#enova-billing-documento-number").classList.add("input-has-error");
        } else {
          document.querySelector("#enova-billing-documento-number").classList.remove("input-has-error");
          if(typeof validateDocumentTypeForm === "function") validateDocumentTypeForm();
        }
        
        if (obj_params.attributes["shipping_method"] === "") {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--title").classList.add("text-has-error");
        } else {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--title").classList.remove("text-has-error");
        }

        if (obj_params.attributes["dispatch_mode"] === "delivery") {
            if (!obj_params.attributes.address || obj_params.attributes.address.trim() === "") {
                document.querySelector("#enova-despacho-direccion").classList.add("input-has-error");
            } else {
                document.querySelector("#enova-despacho-direccion").classList.remove("input-has-error");
            }

            // Validación visual para Referencia
            if (!obj_params.attributes.reference || obj_params.attributes.reference.trim() === "") {
                document.querySelector("#enova-despacho-referencia").classList.add("input-has-error");
            } else {
                document.querySelector("#enova-despacho-referencia").classList.remove("input-has-error");
            }
          
          if (obj_params.attributes.region === "Seleccione...") document.querySelector("#enova-carrito-block-despacho-shipping__departamento").classList.add("input-has-error");
          else document.querySelector("#enova-carrito-block-despacho-shipping__departamento").classList.remove("input-has-error");
          
          if (obj_params.attributes.province === "Seleccione") document.querySelector("#enova-carrito-block-despacho-shipping__provincia").classList.add("input-has-error");
          else document.querySelector("#enova-carrito-block-despacho-shipping__provincia").classList.remove("input-has-error");
          
          if (obj_params.attributes.district === "Seleccione") document.querySelector("#enova-carrito-block-despacho-shipping__distrito").classList.add("input-has-error");
          else document.querySelector("#enova-carrito-block-despacho-shipping__distrito").classList.remove("input-has-error");
        }

        if( document.querySelector("input[name=enova-despacho]:checked") ) {
            document.querySelector("#enova-despacho-delivery-option").parentNode.parentNode.parentNode.classList.remove("input-has-error");
            jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option").hide();
        } else {
            document.querySelector("#enova-despacho-delivery-option").parentNode.parentNode.parentNode.classList.add("input-has-error");
            if( jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option")[0] ) {
                jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option").show();
            } else {
                jQuery("#enova-despacho-delivery-option").parent().parent().parent().append(`<div class="msg-error-not-selected-option">Debes seleccionar tu tipo de Despacho</div>`);
            }
        }

        if( document.querySelector("input[name=enova-billing-doc]:checked") ) {
            document.querySelector("#enova-despacho-billing-boleta").parentNode.parentNode.parentNode.classList.remove("input-has-error");
            jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option").hide();
        } else {
            document.querySelector("#enova-despacho-billing-boleta").parentNode.parentNode.parentNode.classList.add("input-has-error");
            if( jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option")[0] ) {
                jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option").show();
            } else {
                jQuery("#enova-despacho-billing-boleta").parent().parent().parent().append(`<div class="msg-error-not-selected-option">Debes seleccionar tu tipo de comprobante</div>`);
            }
        }

        if( document.querySelector("input[name=enova-despacho-tipo]:checked") ) {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--list").parentNode.parentNode.parentNode.classList.remove("input-has-error");
            jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option").hide();
        } else {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--list").parentNode.parentNode.parentNode.classList.add("input-has-error");
            if( jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option")[0] ) {
                jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option").show();
            } else {
                jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").append(`<div class="msg-error-not-selected-option">Debes seleccionar metodo de envio.</div>`);
            }
        }

        if (jQuery('input[name="enova-billing-doc"]:checked').val() === "factura") {
            document.querySelector("#enova-billing-doc-ruc").classList.add("input-has-error");
            var _comp = DOC_CFG.company || { label: "documento", minLen: 0, maxLen: 0 };
            var _lenTxt = _comp.minLen === _comp.maxLen ? `${_comp.maxLen}` : `${_comp.minLen} a ${_comp.maxLen}`;
            var message_validation = `El campo ${_comp.label} debe tener ${_lenTxt} caracteres`;
            if ($("#enova-billing-doc-ruc").parent().find('.text-has-error').length === 0) {
                $("#enova-billing-doc-ruc").parent().append(`<p class='text-has-error text-typedoc'>${message_validation}</p>`);
            }
        }

        if ( jQuery('input[name="enova-billing-doc"]:checked').val() === "factura" ) {
            if ( jQuery("#enova-billing-doc-razonsocial").val() === "" ) {
                document.querySelector("#enova-billing-doc-razonsocial").classList.add("input-has-error");
            } else {
                document.querySelector("#enova-billing-doc-razonsocial").classList.remove("input-has-error");
            }
        }

        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "false");
        document.querySelector("#enova-message-carrito").textContent = "Debes completar las casillas faltantes en rojo";
        document.querySelector("#enova-message-carrito").classList.add("active");
    }
}

// Construye el select de tipo de documento y el campo de empresa según el país (config).
function renderDocumentsFromConfig() {
    const $sel = jQuery("#enova-billing-documento-type");
    if ($sel.length && DOC_CFG.person && DOC_CFG.person.length) {
        let opts = '<option selected disabled value="">Tipo Documento</option>';
        DOC_CFG.person.forEach(d => { opts += `<option value="${d.value}">${d.label}</option>`; });
        $sel.html(opts);
        const maxLen = Math.max.apply(null, DOC_CFG.person.map(d => d.maxLen));
        jQuery("#enova-billing-documento-number").attr("maxlength", maxLen);
    }
    if (DOC_CFG.company) {
        jQuery("#enova-billing-doc-ruc")
            .attr("placeholder", `Nº de ${DOC_CFG.company.label}`)
            .attr("maxlength", DOC_CFG.company.maxLen);
    }
}

/* -------------------------------------------------------------------------
 * 7. INICIALIZADOR
 * ------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function() {
    renderDocumentsFromConfig();
    setFormDespacho();
    setFormBillingDoc();
    setStoresEventClick();
    calculateShippingMethodByUbigeoSelected();
    calculateShippingMethodToShowOption();
    setRenderCartFormKeypressValidation();
    cartStep1();

    setLogistictProgrammedDateRules();
    setInitCustomerData();
});

$('#enova-carrito-block-despacho-shipping__distrito').change(function() {
    setLogistictProgrammedDateRules();
});

var setCheckerCartDiscountLabel = setInterval(() => {
    if (window.location.href.includes("cart") && !(document.querySelector("#enova_cart-data-submit")) ) {
        setFakeButtonCart();
        clearInterval(setCheckerCartDiscountLabel);

        jQuery(".enova-carrito-block").addClass("active");
        jQuery("#enova_cart-data-submit").show();

        initSetFormDataUbigeosAvailable();
    }
}, 1000);